<form name="form" #f="ngForm" novalidate>
    
    <!-- Enabled Toggle -->
    <ion-item>
        <ion-label class="ion-text-wrap">
            <span class="line1">Enabled</span><br />
            <span class="line2">{{data.enabledStr}}</span>
        </ion-label>
        <ion-toggle 
            id="enabled" 
            name="enabled" 
            [(ngModel)]="data.enabled" 
            (ionChange)="onEnabledChange()" 
            data-test="enableButton">
        </ion-toggle>
    </ion-item>

    <!-- Optional Range Slider -->
    @if (config.hasRangeSlider && config.rangeConfig) {
        <ion-item [disabled]="!data.enabled">
            <ion-label>{{config.rangeConfig.label}}: {{data[config.rangeConfig.propertyName]}}</ion-label>
        </ion-item>
        <ion-item>
            <ion-range 
                [min]="config.rangeConfig.min" 
                [max]="config.rangeConfig.max" 
                [(ngModel)]="data[config.rangeConfig.propertyName]"
                [name]="config.rangeConfig.propertyName"
                (ionChange)="onRangeChange()" 
                [disabled]="!data.enabled">
                <ion-label slot="start">{{config.rangeConfig.min}}</ion-label>
                <ion-label slot="end">{{config.rangeConfig.max}}</ion-label>
            </ion-range>
        </ion-item>
    }

    <!-- Raw Message Input -->
    <ion-item>
        <ion-label class="ion-text-wrap" position="stacked">{{config.messageLabel}}</ion-label>
        <ion-textarea 
            color="secondary" 
            type="text" 
            rows="6" 
            name="rawMessage" 
            #rawMessage="ngModel"
            [ngClass]="{ 'is-invalid': submitted && rawMessage.invalid }" 
            required 
            [(ngModel)]="data.rawMessage"
            id="rawMessage" 
            (ionChange)="onMessageChange()" 
            placeholder="Required."
            [disabled]="!data.enabled" 
            (keyup)="onKeyUp($event)" 
            (click)="onKeyUp($event)" 
            data-test="rawMessage">
        </ion-textarea>
        @if (submitted && rawMessage.invalid) {
            <div data-test="messageErr">
                <div class="validationErrorMsg">Message is required.</div>
            </div>
        }
    </ion-item>

    <!-- Rendered Message Preview -->
    <ion-item>
        <ion-label class="ion-text-wrap" position="stacked">{{config.messagePreviewLabel}}</ion-label>
        <ion-textarea 
            rows="6" 
            readonly 
            name="renderedMessage" 
            [(ngModel)]="data.renderedMessage"
            [disabled]="!data.enabled" 
            [autoGrow]="true" 
            data-test="renderedMessage">
        </ion-textarea>
    </ion-item>
    
    <!-- Character Count Badge -->
    <ion-item>
        <ion-badge 
            class="ion-text-wrap" 
            position="stacked" 
            color="tertiary" 
            slot="end" 
            data-test="message">
            {{data.message}}
        </ion-badge>
    </ion-item>
</form>